import * as React from 'react'
import { DashboardLayout } from 'modules/dashboard/common/dashboard-layout'
import { Button } from 'components/button'

import style from './exception.css'
import { useTranslation } from 'react-i18next'

interface ExceptionWebsocketProps {
  onRetry?: () => void
}

export const ExceptionWebsocket: React.FC<ExceptionWebsocketProps> = ({ onRetry }) => {
  const { t } = useTranslation()

  const handleRetry = () => {
    if (onRetry) {
      onRetry()
      return
    }
    // Full reload from the root re-runs the auth bootstrap and reattempts the
    // websocket connection (mirrors the "Return Home" behaviour of the 500 page).
    window.location.href = '/'
  }

  return (
    <DashboardLayout errorMode>
      <div className={style.root}>
        <div className={style.exceptionContent}>
          <div className={style.text}>{t('errors.websocketConnectionFailed')}</div>
          <div className={style.separator} />
          <div className={style.buttonWrapper}>
            <Button className={style.actionBtn} onClick={handleRetry}>
              {t('errors.websocketConnectionRetry')}
            </Button>
          </div>
        </div>
        <div className={style.listWrapper}>
          <ul className={style.list}>
            <li>
              <span className={style.errorValue}>
                {t('errors.websocketConnectionFailedDescription')}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </DashboardLayout>
  )
}
